import React from "react";
import { CheckCircle2 } from "lucide-react";
import { useContent } from "@/lib/content";
import { getIcon } from "@/lib/icons";

export default function FeesEMI({ onConsult }) {
  const { content } = useContent();
  const f = content.fees || {};
  const plans = f.plans || [];
  return (
    <section id="fees" data-testid="fees-section" className="bg-[#f8fafc] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="font-inter text-sm font-semibold tracking-[0.18em] uppercase text-[#002570]">{f.eyebrow || "Fees & EMI"}</p>
          <h2 className="mt-3 font-rubik text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0f172a] leading-tight text-balance">
            {f.headline_pre || "Transparent fees."} <span className="text-[#002570]">{f.headline_emphasis || "Flexible plans."}</span> {f.headline_post || "No surprises."}
          </h2>
          <p className="mt-4 font-inter text-base md:text-lg text-slate-600">{f.subtitle || "Choose a payment plan that suits your family. Talk to our counsellor for the exact fee for your course and batch."}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {plans.map((p, i) => {
            const Icon = getIcon(p.icon);
            return (
              <div key={i} data-testid={`fee-plan-${i}`} className={`relative bg-white rounded-3xl p-8 border border-slate-100 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 ${i === 0 ? "lg:scale-[1.03] ring-2 ring-[#73c3ff]/40" : ""}`}>
                {p.badge && (
                  <span className="absolute -top-3 right-6 bg-[#73c3ff] text-[#002570] text-[11px] font-inter font-semibold uppercase tracking-wider px-3 py-1 rounded-full">{p.badge}</span>
                )}
                <div className="w-12 h-12 rounded-xl bg-[#002570] text-white flex items-center justify-center mb-5">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="font-rubik text-xl font-semibold text-[#0f172a]">{p.title}</h3>
                <ul className="mt-5 space-y-3">
                  {(p.perks || []).map((perk, j) => (
                    <li key={j} className="flex items-start gap-3 font-inter text-sm text-slate-700">
                      <CheckCircle2 className="w-5 h-5 text-[#002570] mt-0.5 shrink-0" />
                      {perk}
                    </li>
                  ))}
                </ul>
                <button onClick={onConsult} data-testid={`fee-plan-cta-${i}`} className="mt-7 w-full bg-[#002570] text-white hover:bg-[#001a52] rounded-full py-3 font-inter font-medium text-sm transition-colors">
                  Get Exact Fee Details
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
